import {useMutation} from '@apollo/client';
import {CREATE_PHARMACY} from "../pharmacyTypeDefs";

export const useMutationCreatePharmacy = (options?: any): any => (
  useMutation(CREATE_PHARMACY, options)
);
